import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3fc72199&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=3fc72199&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc72199",
  null
  
)

export default component.exports